export const PREVIEW_FINISHED = 'PREVIEW_FINISHED';



// WEBPACK FOOTER //
// ./src/redux/action-types/ui/previewFinished.js